// extracted by mini-css-extract-plugin
export default {"tabContainer":"styles_tabContainer__9LieN","tab":"styles_tab__fNmSq","active":"styles_active__tWWVe","barIndicator":"styles_barIndicator__VVb8u"};